import cookies from "js-cookie";
import * as AuthAPI from '../modules/api/auth';

export const saveTokenExpirationDate = (date, remember = false) => {
  if (remember) {
    const nextYearExpirationDate = new Date();
    nextYearExpirationDate.setFullYear(
      nextYearExpirationDate.getFullYear() + 1
    );

    cookies.set("exp", date, {
      expires: nextYearExpirationDate,
    });
    cookies.set("exp_rm", "1", {
      expires: nextYearExpirationDate,
    });
  } else {
    cookies.set("exp", date);
  }
};

export const isRememberMe = () => {
  return cookies.get("exp_rm") === "1";
};

export const deleteTokenExpirationAndRememberDate = () => {
  cookies.remove("exp");
  cookies.remove("exp_rm");
};

export const getTokenExpirationDate = () => {
  return cookies.get("exp");
};

export const isTokenExpired = () => {
  const expirationDate = getTokenExpirationDate();
  if (!expirationDate) return true;
  const now = new Date();
  const expiration = new Date(expirationDate);
  if (String(expiration) === "Invalid Date") return true;
  const threshold = 60 * 1000;
  return now.getTime() > expiration.getTime() - threshold;
};

let memo = null;

let justRefreshed = false;

export const isJustRefreshed = () => {
  return justRefreshed;
}

export const onSuccessRequest = () => {
  justRefreshed = false;
}

const refreshTokenLogic = async () => {
  try {
    const response = await AuthAPI.refresh();
    const tokenExpirationDate = response.headers["x-token-expires"];
    saveTokenExpirationDate(
      new Date(tokenExpirationDate).toISOString(),
      isRememberMe()
    );
    justRefreshed = true;
    return true;
  } catch (err) {
    console.error(err);
    throw new Error("Failed to refresh accesss token");
  }
};

export const refreshToken = () => {
  if (!memo) {
    // eslint-disable-next-line no-async-promise-executor
    memo = new Promise(async (resolve, reject) => {
      try {
        const result = await refreshTokenLogic();
        resolve(result);
      } catch (err) {
        reject(err);
      } finally {
        memo = null;
      }
    });
  }

  return memo;
};
